import React, { useEffect, useState } from "react";
import { Container, Table, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

export default function SuccessPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      fetchOrder();
    }, 2000);

    fetchOrder();

    return () => clearInterval(interval);
  }, []);

  const fetchOrder = async () => {
    try {
      const res = await axios.get(`https://cafesero.in/admin/order/${id}`);

      if (res.data.status === 200) {
        setOrder(res.data.order);
        setItems(res.data.items);
        setLoading(false);
        setError("");

        // Stop polling if paid
        if (res.data.order.status === "paid") {
          clearInterval();
        }
      } else {
        setError(res.data.message || "Something went wrong");
        setLoading(false);
      }
    } catch (err) {
      console.error(err);

      // Handle 404 or server error
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Failed to fetch order");
      }

      setLoading(false);
    }
  };

  // Loading
  if (loading) {
    return <h4 className="text-center mt-5">⏳ Loading order...</h4>;
  }

  // Error UI
  if (error) {
    return (
      <Container className="text-center py-5">
        <h3 className="text-danger">❌ {error}</h3>
        <Button
          className="mt-3"
          variant="primary"
          onClick={() => navigate("/products")}
        >
          Go to Products
        </Button>
      </Container>
    );
  }

  // ⏳ Processing
  if (order.status !== "paid") {
    return (
      <Container className="text-center py-5">
        <h4>⏳ Processing payment...</h4>
        <p>Please wait, confirming your payment.</p>
      </Container>
    );
  }

  const handlePrint = () => {
    window.print();
  };

  // Success
  return (
    <Container className="py-5">
      <div className="bg-light p-4 rounded shadow">
        <div className="print-area">
          <h2 className="text-success text-center mb-4">
            ✅ Order Placed Successfully
          </h2>

          <div className="mb-4">
            <h5>Order ID: #{order.id}</h5>

            <p>
              <strong>Name:</strong>{" "}
              {`${order.user_name || ""} ${order.last_name || ""}`.trim()}
            </p>

            <p>
              <strong>Email:</strong> {order.email}
            </p>

            <p>
              <strong>Contact:</strong> {order.contact}
            </p>

            <p>
              <strong>Address:</strong>{" "}
              {[
                order.address,
                order.address_2,
                order.city,
                order.state,
                order.pincode,
                order.country,
              ]
                .filter(Boolean)
                .join(", ")}
            </p>
          </div>

          <Table bordered>
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i}>
                  <td>{item.title}</td>
                  <td>₹{item.price}</td>
                  <td>{item.qty}</td>
                  <td>₹{item.total}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <h4 className="text-end">
            Total: ₹{Number(order.total_amount).toLocaleString()}
          </h4>
        </div>
        <div className="mt-4 p-1 d-flex flex-column flex-md-row gap-2 justify-content-center">
          <Button className="me-2" onClick={() => navigate("/products")}>
            Continue Shopping
          </Button>

          <Button variant="success" onClick={handlePrint}>
            🖨️ Print Invoice
          </Button>
        </div>
      </div>
    </Container>
  );
}
